module.exports = __webpack_public_path__ + "assets/smarthelp-ico-pickdate.696a1872.svg";